import $ from 'zepto';
import {
  getFormId,
  checkRowItemValue,
  DEFAULT_DURATION,
  getFieldRow,
} from './utils';
import { searchForRowItemsConfig } from './itemConfig';
import { waitForValueChange } from '../../utils/dom';
import { formSelector } from '../../utils/constants/classes';

const $body = $(document.body);
const forms = {};

const itemsAreValid = (items) => {
  // check for any new config since the init
  searchForRowItemsConfig();

  const invalidItems = items.filter((item) => {
    const { isValid, message } = checkRowItemValue(item);

    if (isValid || !message) {
      return !isValid;
    }

    // check if the item already has an error before adding the new one
    const hasError = item.hasErrorHighlight();

    const removeError = item.replaceFooterMessage({
      message,
      isError: true,
    });

    if (hasError) {
      // NOTE: do not use the reverse function (removeError) when there
      // was already an error to avoid replacing back the first error
      waitForValueChange(item.$element, () => {
        item.removeFooterMessage({ isError: true });
      });
    } else {
      waitForValueChange(item.$element, removeError);
    }

    return true;
  });

  if (invalidItems.length === 0) {
    return true;
  }

  const [firstInvalidItem] = invalidItems;
  const { $row } = firstInvalidItem;
  const row = $row.get(0);
  const scrollIsNeeded = $row.offset().top - window.scrollY < 0;

  if (row.scrollIntoView && scrollIsNeeded) {
    // waiting the animation to finished so
    // scrollIntoView scrolls to the correct position
    setTimeout(() => {
      row.scrollIntoView({
        behavior: 'smooth',
        inline: 'center',
      });
    }, DEFAULT_DURATION);
  }

  return false;
};

const getForm = (id) => forms[id];

const getFormItem = (formId, itemId) => {
  const form = getForm(formId);

  if (!form) {
    return undefined;
  }

  const { items } = form;

  return items[itemId];
};

const registerRowItemInForm = (item) => {
  const $row = getFieldRow(item.field);
  const $form = $row.closest(formSelector);
  const formId = getFormId($form);
  const form = getForm(formId);

  if (form) {
    form.items[item.id] = item;
  }
};

const initForm = ($form) => {
  const formId = getFormId($form);
  const items = {};
  const getItemList = () => Object.keys(items).map((key) => items[key]);
  const on = $form.on.bind($form);

  const onSubmit = (event) => {
    const itemList = getItemList();

    if (!itemsAreValid(itemList)) {
      event.preventDefault();
      $form.trigger('failed-submit');
    }
  };

  forms[formId] = {
    id: formId,
    items,
    getItemList,
    $form,
    on,
  };

  $form.submit(onSubmit);
};

const initForms = ($context = $body) => {
  $context.find(formSelector).each((index, form) => initForm($(form)));
};

export {
  forms,
  getForm,
  getFormItem,
  registerRowItemInForm,
  initForm,
  initForms,
};
